"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5617],{

/***/ 5617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ features_academy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/utils/clevertap.js
var clevertap = __webpack_require__(48028);
// EXTERNAL MODULE: ./src/lib/entities/chat/slice.ts
var slice = __webpack_require__(10707);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./src/lib/api/academy.ts
var academy = __webpack_require__(64846);
;// CONCATENATED MODULE: ./src/features/academy/store.ts
/* eslint-disable import/no-named-as-default-member */ 



var tokenStore = (0,esm/* default */.ZP)(function(set) {
    return {
        token: null,
        isLoading: false,
        createToken: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var response, _data, error, errorType, data, message;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        set({
                            isLoading: true
                        });
                        _ctx.next = 4;
                        return academy/* default.createToken */.ZP.createToken();
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        set({
                            isLoading: false
                        });
                        throw new Error("Error while fetching data");
                    case 8:
                        _data = response.data, error = _data.error, errorType = _data.error_type, data = _data.data, message = _data.message;
                        if (!(error || errorType)) {
                            _ctx.next = 12;
                            break;
                        }
                        set({
                            isLoading: false
                        });
                        throw new Error(message);
                    case 12:
                        set({
                            token: data === null || data === void 0 ? void 0 : data.academy_token
                        });
                        _ctx.next = 18;
                        break;
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](0);
                        set({
                            isLoading: false
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    15
                ]
            ]);
        }))
    };
});
/* harmony default export */ var store = (tokenStore);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/academy/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  padding-top: 70px;\n  border: none;\n  background: ",
        ";\n  overflow: scroll;\n  width: 100%;\n  @media ",
        " {\n    padding-top: 80px;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Container = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-42292270-0"
})(_templateObject(), color/* default.light */.Z.light, device/* default.tablet */.Z.tablet);


;// CONCATENATED MODULE: ./src/features/academy/index.tsx
/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable function-paren-newline */ /* eslint-disable consistent-return */ 

















var ModalShare = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(97570), __webpack_require__.e(88069), __webpack_require__.e(50299), __webpack_require__.e(92961), __webpack_require__.e(33070), __webpack_require__.e(92077), __webpack_require__.e(42298), __webpack_require__.e(33082), __webpack_require__.e(63828), __webpack_require__.e(23304), __webpack_require__.e(51767), __webpack_require__.e(1013), __webpack_require__.e(97081), __webpack_require__.e(49234), __webpack_require__.e(57333), __webpack_require__.e(54392), __webpack_require__.e(12683), __webpack_require__.e(75413), __webpack_require__.e(71682), __webpack_require__.e(66933), __webpack_require__.e(41232), __webpack_require__.e(51468)]).then(__webpack_require__.bind(__webpack_require__, 41232));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41232)
            ];
        }
    },
    ssr: false
});
function Academy() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), iframeUrl = ref[0], setIframeUrl = ref[1];
    var ref1 = (0,react.useState)(false), showShareModal = ref1[0], setShowShareModal = ref1[1];
    var generateToken = store(function(store) {
        return store.createToken;
    });
    var academyToken = store(function(store) {
        return store.token;
    });
    /**
   * Handle Navigate Event from Academy
   * @description change url in window
   * @param eventName event name from academy.stockbit.com
   * @param parameter event paramenter
   */ var handleNavigateEvent = function(eventName) {
        var parameter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        if (!parameter || !eventName) {
            return;
        }
        var isUnboxingList = eventName.toLowerCase().includes("unboxing saham viewed");
        var isArticleViewed = eventName.toLowerCase().includes("unboxing article viewed");
        var isVolumeChanged = eventName.toLowerCase().includes("unboxing volume changed");
        // Should only apply to `/academy/unboxing` and `/unboxing` only.
        if (isUnboxingList) {
            // Academy webapp resides on both /academy/[[..slugs]] and /unboxing/[[..slugs]]
            var windowUrl = router.asPath.startsWith("/academy") ? "/academy/unboxing" : "/unboxing";
            router.replace(windowUrl, windowUrl, {
                shallow: true
            });
            return;
        }
        // Should only apply to `/academy/unboxing/{id}` and `/unboxing/volume/{id}` only.
        if (isVolumeChanged || isArticleViewed) {
            // Academy webapp resides on both /academy/[[..slugs]] and /unboxing/[[..slugs]]
            var windowUrl1 = router.asPath.startsWith("/academy") ? "/academy/unboxing" : "/unboxing";
            // unboxing volume
            var volume = Number(parameter.Volume);
            if (volume) {
                var subpath = router.asPath.startsWith("/academy") ? "/academy/unboxing" : "/unboxing/volume";
                windowUrl1 = "".concat(subpath, "/").concat(volume);
            }
            router.replace(windowUrl1, windowUrl1, {
                shallow: true
            });
            return;
        }
        // Lines 68-94 are the default conditions.
        // It applies to anything else
        // (`/academy`, `/academy/modules/1`, `/academy/modules/1/chapters/3`, etc).
        var params = {
            modules: Number(parameter["Module ID"]),
            chapters: Number(parameter["Chapter ID"]),
            lessons: Number(parameter["Lesson ID"])
        };
        // remove undefined params
        Object.keys(params).forEach(function(key) {
            if (!params[key]) {
                delete params[key];
            }
        });
        // change browser window url on academy event
        if (Object.keys(params).length > 0) {
            var windowUrl2 = "/academy";
            Object.keys(params).forEach(function(param) {
                windowUrl2 = "".concat(windowUrl2, "/").concat(param, "/").concat(params[param]);
            });
            router.replace(windowUrl2, windowUrl2, {
                shallow: true
            });
            return;
        }
        router.replace("/academy", "/academy", {
            shallow: true
        });
    };
    var academyEventListener = function(event) {
        if (!event.data || typeof event.data !== "string") {
            return;
        }
        var postMessageData = {
            fn: undefined,
            data: undefined
        };
        try {
            postMessageData = JSON.parse(event.data);
        } catch (error) {
            return;
        }
        // check if postmessage contains fn and data.
        if (!postMessageData.fn && postMessageData.data) {
            return;
        }
        var fn = postMessageData.fn, data = postMessageData.data;
        if (fn === "academyAnalyticsEvent") {
            (0,clevertap/* academyEventAnalytic */.ze)(data.event_name, data.parameter);
        }
        if (fn === "academyAnalyticsEvent" && data.action === "navigation") {
            return handleNavigateEvent(data.event_name, data.parameter);
        }
        if (fn === "unboxingVolume") {
            return handleNavigateEvent("Unboxing Volume Changed", data.parameter);
        }
        // User Profiling event
        if (fn === "academyUserProfilingTracker") {
            return (0,clevertap/* academyUserProfiling */.nh)(data);
        }
        if (fn === "academyShareUnboxingEvent") {
            setShowShareModal(true);
        }
        if (fn === "academyNavigationEvent") {
            window.open(data.url, data.target);
        }
        if (fn === "popstate") {
            // When `academy` webapp in iframe try to reauthenticate with `/auth`,
            // it means users want to get out of the page. They hit the browser's
            // back buttton until it reaches academy home page.
            if (data.href.includes("/auth")) {
                // Just pop the last 2 records that consist of iframe and the previous page url.
                // We don't need to store or track the last previous route/pathname and
                // "replace" the current URL with it. Simpler and not clever.
                window.history.go(-2);
            }
        }
    };
    var getRedirectToUrl = function() {
        var asPath = router.asPath;
        // remove unessesary url query
        var redirectUrl = new URLSearchParams(window.location.search);
        redirectUrl.delete("refresh");
        redirectUrl.delete("source");
        redirectUrl.delete("shared");
        var isDefaultPath = asPath === "/academy/" || asPath === "/academy" || asPath.includes("?refresh=1");
        if (isDefaultPath) {
            return "/";
        }
        var redirectToUrl = "";
        // Redirect special case lesson page with query params
        if (redirectUrl.has("lessonId")) {
            redirectToUrl = redirectUrl.toString();
            redirectToUrl = "?".concat(redirectToUrl);
        }
        var urlpath = asPath.split("?")[0];
        return urlpath.replace("/academy", "").replace("/academy/", "").replace("/volume", "") + redirectToUrl;
    };
    var generateIframeUrl = function() {
        var UNIX_TIMESTAMP = Math.floor(Date.now() / 1000);
        var query = {
            token: academyToken,
            timestamp: UNIX_TIMESTAMP
        };
        if (router.query.redirect_to) {
            query.redirect_to = router.query.redirect_to;
        } else {
            query.redirect_to = getRedirectToUrl();
        }
        var urlParams = new URLSearchParams(query);
        setIframeUrl("".concat(api/* STOCKBIT_ACADEMY_URL */.BW, "/auth?").concat(urlParams));
    };
    (0,react.useEffect)(function() {
        generateToken();
        // replace current style on main container to prevent overflow with height
        document.getElementById("main-container").setAttribute("style", "\n          margin-top: 0px !important;\n          max-width: unset;\n          width: auto;\n          padding-right: 0px;\n          margin-left: 0px;\n          height: 100vh;\n          position: relative;\n        ");
    }, []);
    (0,react.useEffect)(function() {
        generateIframeUrl();
        window.addEventListener("message", academyEventListener);
        return function() {
            window.removeEventListener("message", academyEventListener);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        academyToken
    ]);
    (0,react.useEffect)(function() {
        // Hard refresh if user click Academy Link on Navbar
        var isPathNameAllowed = router.asPath !== router.pathname;
        if (router.asPath.includes("refresh=1") && isPathNameAllowed) {
            generateIframeUrl();
        }
    }, [
        router.asPath
    ]);
    var shareToChat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(chatData) {
            var send, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.sendBulkChat */.Sz.sendBulkChat((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, chatData), {
                            attachment_url: ""
                        })));
                    case 2:
                        send = _ctx.sent;
                        error = send.payload.error;
                        if (!error) {
                            setShowShareModal(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function shareToChat(chatData) {
            return _ref.apply(this, arguments);
        };
    }();
    var sharedUrl = (0,react.useMemo)(function() {
        var path = !app/* PROJECT_FOLDER */.sP || app/* PROJECT_FOLDER */.sP === "/" ? "" : "/".concat(app/* PROJECT_FOLDER */.sP);
        if (router.asPath.includes("unboxing")) {
            var unboxingIdPath = router.asPath.substring(router.asPath.slice(1, -1).lastIndexOf("/") + 1);
            return "".concat(window.location.origin).concat(path, "/unboxing/volume").concat(unboxingIdPath);
        }
        return "".concat(window.location.origin).concat(path).concat(router.asPath, "?shared=true");
    }, [
        router.asPath
    ]);
    var handleCopyLink = function() {
        (0,general/* copyTextToClipboard */.TE)(sharedUrl, function() {
            return (0,AlertErrorMessage/* default */.Z)("Link Copied", successMessage/* default.SNACKBAR_GREEN */.Z.SNACKBAR_GREEN, true);
        });
    };
    if (iframeUrl === "") {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                allowFullScreen: true,
                allow: "autoplay",
                src: iframeUrl,
                id: "academy-iframe"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalShare, {
                visible: showShareModal,
                onCancel: function() {
                    return setShowShareModal(false);
                },
                title: "Share",
                sendChat: function(chatData) {
                    return shareToChat(chatData);
                },
                hasSocialMedia: true,
                hasShareInput: true,
                hasCopyButton: true,
                urlToShare: sharedUrl,
                defaultSharedMessage: sharedUrl,
                onCopy: handleCopyLink
            })
        ]
    });
}
/* harmony default export */ var features_academy = (Academy);


/***/ }),

/***/ 64846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports createToken, getUnboxings, getModules, getChapterLessons, getUnboxingDetail */
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ 

var requestExodus = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
/**
 * Create Token
 */ var createToken = function() {
    return requestExodus.post("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/academy/tokens/new"));
};
/**
 * Get Unboxing Content
 * @returns {APIResponse}
 */ var getUnboxings = function() {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/academy/unboxing?limit=5"));
};
/**
 * Get List Modules
 * @returns {APIResponse}
 */ var getModules = function() {
    return fetch("".concat(API_EXODUS_URL, "/academy/modules"), {
        method: "get"
    });
};
/**
 * Get List Lesson From Chapters
 * @param {number} chapterId - chapter id
 * @returns {APIResponse}
 */ var getChapterLessons = function(chapterId) {
    return fetch("".concat(API_EXODUS_URL, "/academy/lessons?chapter_id=").concat(chapterId), {
        method: "get"
    });
};
/**
 * Get Unboxing Detail
 * @param {number} unboxingId - unboxing id
 * @returns {APIResponse}
 */ var getUnboxingDetail = function(unboxingId) {
    return fetch("".concat(API_EXODUS_URL, "/academy/unboxing/").concat(unboxingId), {
        method: "get"
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createToken: createToken,
    getUnboxings: getUnboxings
});


/***/ })

}]);